import { render, staticRenderFns } from "./BeVenueTeam.vue?vue&type=template&id=77aa4784&scoped=true"
import script from "./BeVenueTeam.vue?vue&type=script&lang=js"
export * from "./BeVenueTeam.vue?vue&type=script&lang=js"
import style0 from "./BeVenueTeam.vue?vue&type=style&index=0&id=77aa4784&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77aa4784",
  null
  
)

export default component.exports